import { useTheme } from '../../hooks/useTheme'

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <>
      <button
        className="tt-root"
        onClick={toggleTheme}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        {/* Track */}
        <span className={`tt-track${isDark ? ' tt-track--dark' : ' tt-track--light'}`}>
          {/* Sun icon */}
          <span className="tt-icon tt-icon--sun" aria-hidden>☀️</span>
          {/* Moon icon */}
          <span className="tt-icon tt-icon--moon" aria-hidden>🌙</span>
          {/* Thumb */}
          <span className={`tt-thumb${isDark ? ' tt-thumb--dark' : ' tt-thumb--light'}`} />
        </span>
      </button>

      <style>{`
        .tt-root {
          display: inline-flex;
          align-items: center;
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          flex-shrink: 0;
          border-radius: 999px;
          outline-offset: 3px;
        }
        .tt-root:focus-visible { outline: 2px solid var(--accent); }

        /* ── Track ── */
        .tt-track {
          position: relative;
          display: flex;
          align-items: center;
          width: 52px;
          height: 28px;
          border-radius: 999px;
          padding: 0 4px;
          justify-content: space-between;
          transition: background 0.3s ease, border-color 0.3s ease;
          border: 1.5px solid transparent;
        }
        .tt-track--dark {
          background: #1e3a5f;
          border-color: #2d5a9e;
        }
        .tt-track--light {
          background: #fef3c7;
          border-color: #fbbf24;
        }

        /* ── Icons ── */
        .tt-icon {
          font-size: 0.75rem;
          line-height: 1;
          z-index: 1;
          transition: opacity 0.2s ease;
          user-select: none;
        }
        .tt-icon--sun  { opacity: ${isDark ? 0.3 : 1}; }
        .tt-icon--moon { opacity: ${isDark ? 1 : 0.3}; }

        /* ── Thumb ── */
        .tt-thumb {
          position: absolute;
          top: 3px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      background 0.3s ease,
                      box-shadow 0.3s ease;
          box-shadow: 0 1px 4px rgba(0,0,0,0.35);
        }
        .tt-thumb--dark {
          left: calc(52px - 20px - 3px - 1.5px);
          background: #93c5fd;
          box-shadow: 0 1px 4px rgba(0,0,0,0.4), 0 0 8px rgba(147,197,253,0.4);
        }
        .tt-thumb--light {
          left: 3px;
          background: #fbbf24;
          box-shadow: 0 1px 4px rgba(0,0,0,0.2), 0 0 8px rgba(251,191,36,0.4);
        }
      `}</style>
    </>
  )
}
